export class TooManyRequestsError extends Error {
  code = 429;

  constructor() {
    super();
  }
}
